import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';

export const axios = createAxiosInstance(env.communityApiUrl, {
  camelizeKeys: true,
});

export async function getInboxViews(axiosConfig = {}) {
  return axios.get('/inbox_views', axiosConfig);
}

export async function getInboxView(viewId, axiosConfig = {}) {
  const url = `/inbox_views/${viewId}`;
  return axios.get(url, axiosConfig);
}

export async function createInboxView(payload, axiosConfig = {}) {
  return axios.post('/inbox_views', payload, axiosConfig);
}

export async function updateInboxView(viewId, payload, axiosConfig = {}) {
  return axios.patch(`/inbox_views/${viewId}`, payload, axiosConfig);
}

export async function leaveCustomInboxView(viewId, axiosConfig = {}) {
  return axios.delete(`/inbox_views/${viewId}/user_access_grants`, axiosConfig);
}

export async function deleteCustomInboxView(viewId, axiosConfig = {}) {
  const url = `/inbox_views/${viewId}`;
  return axios.delete(url, axiosConfig);
}
